function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import styles from "./styles.css";
var DRAG_PIXEL_THRESHOLD = 10;
var useDraggable = function useDraggable(_ref) {
  var onDrag = _ref.onDrag,
    onDragEnd = _ref.onDragEnd;
  var slideElementRef = React.useRef(null);
  var originX = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDragging = _React$useState2[0],
    setIsDragging = _React$useState2[1];
  var doDrag = React.useCallback(function (distance) {
    onDrag({
      distance: distance,
      target: slideElementRef.current
    });
    setIsDragging(true);
  }, [onDrag]);
  var endDrag = React.useCallback(function () {
    if (isDragging) {
      onDragEnd();
    }
    setIsDragging(false);
    originX.current = null;
    slideElementRef.current = null;
  }, [onDragEnd, isDragging]);

  /**
   * Global handlers
   */
  React.useEffect(function () {
    var onMouseOut = function onMouseOut(evt) {
      if (originX.current !== null && (!evt.relatedTarget || evt.relatedTarget.nodeName === 'HTML')) {
        endDrag();
      }
    };
    var onMouseUp = function onMouseUp(evt) {
      endDrag();
      evt.preventDefault();
    };
    var onMouseMove = function onMouseMove(evt) {
      if (originX.current === null) {
        return;
      }
      var difference = originX.current - evt.clientX;
      if (Math.abs(difference) >= 15) {
        doDrag(difference);
        evt.preventDefault();
      }
    };
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseout', onMouseOut);
    return function () {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseout', onMouseOut);
    };
  }, [isDragging, originX, onDrag, onDragEnd, doDrag, endDrag]);

  /**
   * Draggable container handlers
   */
  return React.useMemo(function () {
    var onMouseDown = function onMouseDown(evt) {
      originX.current = evt.clientX;
      slideElementRef.current = evt.target;
      evt.preventDefault();
    };
    var onDragStart = function onDragStart(evt) {
      evt.preventDefault();
    };
    var onTouchStart = function onTouchStart(evt) {
      originX.current = evt.touches[0].clientX;
      slideElementRef.current = evt.target;
      evt.preventDefault();
    };
    var onTouchMove = function onTouchMove(evt) {
      if (originX.current === null) {
        return;
      }
      var difference = originX.current - evt.touches[0].clientX;
      if (Math.abs(difference) < DRAG_PIXEL_THRESHOLD) {
        return;
      }
      doDrag(difference);
      evt.preventDefault();
    };
    return {
      onDragStart: onDragStart,
      onTouchStart: onTouchStart,
      onTouchMove: onTouchMove,
      onTouchEnd: endDrag,
      onMouseDown: onMouseDown,
      // Disable pointer events to avoid accidentally clicking on links in carousel
      // While intention is to scroll
      className: isDragging ? styles.disablePointerEvents : ''
    };
  }, [isDragging, originX, doDrag, endDrag]);
};
export default useDraggable;